import React from 'react';
import Chip from '../../../Chip';
import { CommonTriggerProps } from './types';

export type ChipDropdownTriggerProps = {
  label: string | React.ReactNode;
  withCaret?: boolean;
  chipRef: React.RefObject<HTMLButtonElement>;
  selected: boolean;
};
export const ChipDropdownTrigger = ({
  label,
  expanded,
  id,
  disabled,
  withCaret,
  toggleDropdown,
  chipRef,
  selected,
}: ChipDropdownTriggerProps & CommonTriggerProps): JSX.Element => {
  return (
    <Chip
      // Chip is kind of messed up.  Active controls the visual state of the chip
      active={selected}
      // And selected controls the caret direction
      selected={expanded}
      onClick={toggleDropdown}
      htmlFor={id}
      disabled={disabled}
      tabIndex={0}
      ref={chipRef}
      withCaret={withCaret}
    >
      {label}
    </Chip>
  );
};
